import React, { useState, useEffect } from "react";
import cx from "classnames";
import { withTranslation } from "react-i18next";
import HistoryHeader from "./Header";
import HistoryContent from "./Content";
import { groupBy } from "lodash";

import Loader from "../Loader";
import BaseService from "../../../../services/BaseService";
import HistoryPagination from "./HistoryPagination";

import { HistoryItemTypes } from "../../../../constants";

import "./styles.scss";

const LIMIT = 20;

const HistoryTab = props => {
    const {
        t,
        withBottomPanel,
        objectType = "",
        id,
        limit = LIMIT,
        customFilters,
        customHistoryKey,
        customData,
        withoutPagination,
        withReverse,
        historyHeightToExtract,
    } = props;

    // State variables
    const [total, setTotal] = useState(0);
    const [history, setHistory] = useState({});
    const [isLoading, setIsLoading] = useState(false); // isLoading state for history
    const [isFiltersLoading, setIsFiltersLoading] = useState(true); // isLoading state for history filters
    const [filters, setFilters] = useState([]); // Stores available filters from backend
    const [selectedFilter, setSelectedFilter] = useState(""); // Selected filter

    const [page, setPage] = useState(1);
    const [query, setQuery] = useState("");

    // const withPagination = !withoutPagination && total > limit;
    const withPagination = !withoutPagination;

    const handleSearchChange = searchQuery => {
        setPage(1);
        setQuery(searchQuery);
    };

    const getHistory = async () => {
        const start = page === 1 ? 0 : (page - 1) * limit;
        const defaultData = {
            data: {
                limit,
                start,
                filter: selectedFilter,
                query,
            },
            pathParams: { objectType, id },
        };

        setIsLoading(true);

        const url = customHistoryKey ? customHistoryKey : "get_data_history";
        const data = customData ? { data: { query, filter: selectedFilter, ...customData } } : defaultData;

        try {
            const response = await BaseService.get(url, data);
            if (response.success && response.result) {
                // setHistory(response.result);
                setTotal(response.total);
                const items = response.result.filter(item => Object.values(HistoryItemTypes).includes(item.type));
                if (withReverse) {
                    items.reverse();
                }
                setHistory(groupBy(items, "orderDate"));
            } else {
                console.log("HistoryTab::getHistory: Response error");
            }
        } catch (e) {
            console.error("HistoryTab::getHistory: Error", e);
        } finally {
            setIsLoading(false);
        }
    };

    const getFilters = async () => {
        setIsFiltersLoading(true);
        const data = { pathParams: { objectType } };

        try {
            const response = await BaseService.get("get_history_filters", data);
            if (response.success && response.result) {
                setFilters(response.result);
                const defaultFilter = response.result.find(f => f.default);
                if (defaultFilter) {
                    setSelectedFilter(defaultFilter.code);
                }
            } else {
                console.log("HistoryTab::getFilters: Response error");
            }
        } catch (e) {
            console.error("HistoryTab::getFilters: Error", e);
        } finally {
            setIsFiltersLoading(false);
        }
    };

    const handleFilterSelect = (filterCode, event) => {
        event.stopPropagation();
        setSelectedFilter(filterCode);
        setPage(1);
    };

    const onPageChange = ({ page }) => setPage(page);

    useEffect(() => {
        // customFilters => hardcoded filters for Appeal
        if (customFilters && Array.isArray(customFilters) && customFilters.length > 0) {
            setIsFiltersLoading(false);
            setFilters(customFilters);
            const defaultFilter = customFilters.find(f => f.default);
            if (defaultFilter) {
                setSelectedFilter(defaultFilter.code);
            }
        } else {
            getFilters();
        }
    }, []);

    useEffect(() => {
        if (selectedFilter) {
            getHistory();
        }
    }, [selectedFilter, query, page]);


    useEffect(() => {
        if (selectedFilter) {
            setPage(1)
            setQuery("");
            getHistory();
        }
    }, [id]);

    const customHeightStyles = historyHeightToExtract ? { height: `calc(100vh - ${historyHeightToExtract}px)`} : {};

    return (
        <div className={cx("history-tab-container", { "with-bottom-panel": withBottomPanel })} style={customHeightStyles}>
            <div className="history-tab">
                {isFiltersLoading ? (
                    <Loader />
                ) : (
                    <>
                        <HistoryHeader
                            t={t}
                            filters={filters}
                            selectedFilter={selectedFilter}
                            onFilterSelect={handleFilterSelect}
                            onSearchChange={handleSearchChange}
                            onRefresh={getHistory}
                        />

                        <HistoryContent
                            t={t}
                            isLoading={isLoading}
                            history={history}
                            query={query}
                            // isReverse={withReverse}
                        />

                        {withPagination && (
                            <HistoryPagination
                                t={t}
                                page={page}
                                total={total}
                                limit={limit}
                                onChange={onPageChange}
                                containerClassName="history-pagination"
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default withTranslation()(HistoryTab);
